import React, { Component } from "react";
import SubNav from "../../shared/subnav/SubNav";
import styles from "./Reporting.module.scss";
import { Grid } from "@material-ui/core";
import { base64FileDownload, fileDownload } from "../../utils/FileDownloadUtil";
import { withTranslation } from "react-i18next";
import POReportingClient from "../../shared/clients/POReportingClient";
import { logMsg } from "../../common/Logger";

class POReporting extends Component {
  constructor(props) {
    super(props);

    this.RegionReports = [
      {
        name: "EU Region EMP NSC Enrolment Report",
        key: "report1",
        downloadLink: this.handleDownloadLinkRegionNSCReport.bind(this),
      },
      {
        name: "EU Region EMP Dealer Enrolment Report",
        downLoadName: "Reporting.downloadDealerReport",
        key: "report2",
        downloadLink: this.handleDownloadLinkRegionDealerReport.bind(this),
      },
      {
        name: "EU Region EMP Pricing Report",
        downLoadName: "Reporting.downloadDealerPricingReport",
        key: "report3",
        downloadLink: this.handleDownloadLinkRegionPricingReport.bind(this),
      },
      {
        name: "Transparent Pricing Report",
        downLoadName: "Reporting.downloadTransparentPricingReport",
        key: "report4",
        downloadLink:
          this.handleDownloadLinkRegionTransparentPricingReport.bind(this),
      },
      {
        name: "Transparent Accessories Pricing Report",
        downLoadName: "Reporting.downloadTransparentAccessoriesPricingReport",
        key: "report5",
        downloadLink:
          this.handleDownloadLinkRegionTransparentAccessoriesPricingReport.bind(
            this
          ),
      },
    ];

    this.HourlyDailyReports = [
      {
        name: "Full History - Online Sales Dealer Order Report",
        filterData: false,
        key: "dailyReport",
        downloadLink: this.downloadDailyHourlyOrderReport.bind(this),
      },
      {
        name: "48 Hour - Online Sales Dealer Order Report",
        filterData: true,
        key: "hourlyReport",
        downloadLink: this.downloadDailyHourlyOrderReport.bind(this),
      },
    ];

    this.NscLeadTimesReports = [
      {
        name: "NSC Lead Times Report",
        key: "leadTimeReport",
        downloadLink: this.handleDownloadLinkNSCLeadTimesReport.bind(this),
      },
      {
        name: "Delivery Ranges Report",
        downLoadName: "Reporting.downloadDeliveryRangesReport",
        key: "deliveryRangesReport",
        downloadLink: this.downloadDeliveryRangesReport.bind(this),
      },
    ];
  }

  handleDownloadLinkRegionPricingReport = (report) => {
    this.props.hideOrShow(true);
    POReportingClient.downloadCrossDealerPricingReportInCsv(
      this.props.user.token
    )
      .then((res) => {
        const filename = report.name + ".csv";
        const BOM = "\uFEFF";
        const response = BOM + res;
        fileDownload(
          decodeURIComponent(response),
          "text/csv;charset=utf-8;",
          filename
        );
      })
      .catch()
      .finally(() => {
        this.props.hideOrShow(false);
      });
  };

  handleDownloadLinkRegionTransparentPricingReport = (report) => {
    this.props.hideOrShow(true);
    POReportingClient.downloadTransparentPricingReport(this.props.user)
      .then((res) => {
        const filename = report.name + ".csv";
        const BOM = "\uFEFF";
        const response = BOM + res;
        fileDownload(
          decodeURIComponent(response),
          "text/csv;charset=utf-8;",
          filename
        );
      })
      .catch()
      .finally(() => {
        this.props.hideOrShow(false);
      });
  };

  handleDownloadLinkRegionTransparentAccessoriesPricingReport = (report) => {
    this.props.hideOrShow(true);
    POReportingClient.downloadTransparentAccessoriesPricingReport(
      this.props.user
    )
      .then((res) => {
        const filename = report.name + ".csv";
        const BOM = "\uFEFF";
        const response = BOM + res;
        fileDownload(
          decodeURIComponent(response),
          "text/csv;charset=utf-8;",
          filename
        );
      })
      .catch()
      .finally(() => {
        this.props.hideOrShow(false);
      });
  };

  handleDownloadLinkRegionNSCReport = (report) => {
    this.props.hideOrShow(true);
    POReportingClient.downloadNSCActivationReportInCsv(this.props.user.token)
      .then((res) => {
        const filename = report.name + ".csv";
        const BOM = "\uFEFF";
        const response = BOM + res;
        fileDownload(
          decodeURIComponent(response),
          "text/csv;charset=utf-8;",
          filename
        );
      })
      .catch()
      .finally(() => {
        this.props.hideOrShow(false);
      });
  };

  handleDownloadLinkRegionDealerReport = (report) => {
    this.props.hideOrShow(true);
    POReportingClient.downloadCrossDealerActivationReportInCsv(
      this.props.user.token
    )
      .then((res) => {
        const filename = report.name + ".csv";
        const BOM = "\uFEFF";
        const response = BOM + res;
        fileDownload(
          decodeURIComponent(response),
          "text/csv;charset=utf-8;",
          filename
        );
      })
      .catch()
      .finally(() => {
        this.props.hideOrShow(false);
      });
  };

  handleDownloadLinkNSCLeadTimesReport = (report) => {
    this.props.hideOrShow(true);
    POReportingClient.downloadNSCLeadTimesReportInCsv(this.props.user.token)
      .then((res) => {
        const filename = report.name + ".csv";
        const BOM = "\uFEFF";
        const response = BOM + res;
        fileDownload(
          decodeURIComponent(response),
          "text/csv;charset=utf-8;",
          filename
        );
      })
      .catch()
      .finally(() => {
        this.props.hideOrShow(false);
      });
  };

  downloadDeliveryRangesReport = (report) => {
    this.props.hideOrShow(true);
    POReportingClient.downloadDealerDeliveryRangesInCsv(this.props.user)
      .then((response) => {
        const filename = this.props.t(report.downLoadName) + ".csv";
        fileDownload(
          decodeURIComponent(response),
          "text/csv;charset=utf-8;",
          filename,
          "delivery-ranges-report"
        );
      })
      .catch((reason) => {
        logMsg("reason", reason);
      })
      .finally(() => {
        this.props.hideOrShow(false);
      });
  };

  downloadDailyHourlyOrderReport = (report) => {
    this.props.hideOrShow(true);
    POReportingClient.downloadDailyHourlyOrderReportXlsx(
      this.props.user,
      report.filterData
    )
      .then((res) => {
        const filename = report.name + ".xlsx";
        const BOM = "\uFEFF";
        const response = BOM + res;
        base64FileDownload(
          decodeURIComponent(response),
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          filename
        );
      })
      .catch()
      .finally(() => {
        this.props.hideOrShow(false);
      });
  };

  render() {
    return (
      <div id="reporting">
        <section className="pageWrapper">
          <div id="reportingHeader">
            <SubNav
              dashboard={false}
              title={this.props.t("Reporting.subnav1")}
              {...this.props}
            />
          </div>
          <div>
            <Grid
              item
              className={`${styles.headerContainer} ${styles.rowDiv} pagePaddingLeft pagePaddingRight`}
            >
              <div>{this.props.t("Reporting.columnTitle1")}</div>
            </Grid>
            <div>
              {this.RegionReports.map((report) => (
                <React.Fragment key={report.key}>
                  <Grid
                    container
                    className={`${styles.rowDiv} pagePaddingLeft pagePaddingRight`}
                  >
                    <Grid item md={10}>
                      <div className={styles.colValues}>{report.name}</div>
                    </Grid>
                    <Grid item md={2} className={`${styles.end}`}>
                      <a
                        href={null}
                        className={styles.link}
                        id={report.key}
                        onClick={() => report.downloadLink(report)}
                      >
                        {this.props.t("Reporting.download")}
                      </a>
                    </Grid>
                  </Grid>
                </React.Fragment>
              ))}
              {this.HourlyDailyReports.map((report) => (
                <React.Fragment key={report.key}>
                  <Grid
                    container
                    className={`${styles.rowDiv} pagePaddingLeft pagePaddingRight`}
                  >
                    <Grid item md={10}>
                      <div className={styles.colValues}>{report.name}</div>
                    </Grid>
                    <Grid item md={2} className={`${styles.end}`}>
                      <a
                        href={null}
                        className={styles.link}
                        id={report.key}
                        onClick={() => report.downloadLink(report)}
                      >
                        {this.props.t("Reporting.download")}
                      </a>
                    </Grid>
                  </Grid>
                </React.Fragment>
              ))}
              {this.NscLeadTimesReports.map((report) => (
                <React.Fragment key={report.key}>
                  <Grid
                    container
                    className={`${styles.rowDiv} pagePaddingLeft pagePaddingRight`}
                  >
                    <Grid item md={10}>
                      <div className={styles.colValues}>{report.name}</div>
                    </Grid>
                    <Grid item md={2} className={`${styles.end}`}>
                      <a
                        href={null}
                        className={styles.link}
                        id={report.key}
                        onClick={() => report.downloadLink(report)}
                      >
                        {this.props.t("Reporting.download")}
                      </a>
                    </Grid>
                  </Grid>
                </React.Fragment>
              ))}
            </div>
          </div>
        </section>
      </div>
    );
  }
}

export default withTranslation("emp")(POReporting);
